export const checkCardsFeeIdentical = (cardData) => {
    let cardFeeIdentical = false;
    // Accepts Cards
    const acceptsCards = [cardData?.isAcceptAmericanExpress, cardData?.isAcceptMasterCard, cardData?.isAcceptVisa]
    // Fee Types
    const processingFeeType = [cardData?.amexProcessingFeeType, cardData?.visaProcessingFeeType, cardData?.mastercardProcessingFeeType]
    const secondProcessingFeeType = [cardData?.amexSecondProcessingFeeType, cardData?.visaSecondProcessingFeeType, cardData?.mastercardSecondProcessingFeeType]
    const minFeeType = [cardData?.amexMinPaymentFeeType, cardData?.visaMinPaymentFeeType, cardData?.mastercardMinPaymentFeeType]
    const maxFeeType = [cardData?.amexMaxPaymentFeeType, cardData?.visaMaxPaymentFeeType, cardData?.mastercardMaxPaymentFeeType]
    const incrementalFeeType = [cardData?.amexIncrementalFeeType, cardData?.visaIncrementalFeeType, cardData?.mastercardIncrementalFeeType]
    // Fee Values
    const processingFeeValue = [cardData?.amexProcessingFeeValue, cardData?.visaProcessingFeeValue, cardData?.mastercardProcessingFeeValue]
    const secondProcessingFeeValue = [cardData?.amexSecondProcessingFeeValue, cardData?.visaSecondProcessingFeeValue, cardData?.mastercardSecondProcessingFeeValue]
    const minFeeValue = [cardData?.amexMinPaymentFeeValue, cardData?.visaMinPaymentFeeValue, cardData?.mastercardMinPaymentFeeValue]
    const maxFeeValue = [cardData?.amexMaxPaymentFeeValue, cardData?.visaMaxPaymentFeeValue, cardData?.mastercardMaxPaymentFeeValue]
    const incrementalFeeValue = [cardData?.amexIncrementalFeeValue, cardData?.visaIncrementalFeeValue, cardData?.mastercardIncrementalFeeValue]
    // Payment Amount values
    const minPayment = [cardData?.americanExpressMinPaymnet, cardData?.visaMinPayment, cardData?.mastercardMinPayment]
    const maxPayment = [cardData?.americanExpressMaxPayment, cardData?.visaMaxPayment, cardData?.mastercardMaxPayment]
    const incrementalPayment = [cardData?.amexIncrementalPaymentAmount, cardData?.visaIncrementalPaymentAmount, cardData?.mastercardIncrementalPaymentAmount]
    const variableFee = [cardData?.isAcceptAmexVariableFee, cardData?.isAcceptVisaVariableFee, cardData?.isAcceptMasterCardVariableFee]

    if (!acceptsCards.every(element => { return element === acceptsCards[0] })) {
        return false;
    } else {
        cardFeeIdentical = true;
    }

    if (!processingFeeType.every(element => { return element === processingFeeType[0] })) {
        return false;
    } else {
        cardFeeIdentical = true;
    }
    if (!secondProcessingFeeType.every(element => { return element === secondProcessingFeeType[0] })) {
        return false;
    } else {
        cardFeeIdentical = true;
    }
    if (!minFeeType.every(element => { return element === minFeeType[0] })) {
        return false;
    } else {
        cardFeeIdentical = true;
    }
    if (!maxFeeType.every(element => { return element === maxFeeType[0] })) {
        return false;
    } else {
        cardFeeIdentical = true;
    }
    if (!incrementalFeeType.every(element => { return element === incrementalFeeType[0] })) {
        return false;
    } else {
        cardFeeIdentical = true;
    }
    if (!processingFeeValue.every(element => { return element === processingFeeValue[0] })) {
        return false;
    } else {
        cardFeeIdentical = true;
    }
    if (!secondProcessingFeeValue.every(element => { return element === secondProcessingFeeValue[0] })) {
        return false;
    } else {
        cardFeeIdentical = true;
    }
    if (!minFeeValue.every(element => { return element === minFeeValue[0] })) {
        return false;
    } else {
        cardFeeIdentical = true;
    }
    if (!maxFeeValue.every(element => { return element === maxFeeValue[0] })) {
        return false;
    } else {
        cardFeeIdentical = true;
    }
    if (!incrementalFeeValue.every(element => { return element === incrementalFeeValue[0] })) {
        return false;
    } else {
        cardFeeIdentical = true;
    }
    if (!minPayment.every(element => { return element === minPayment[0] })) {
        return false;
    } else {
        cardFeeIdentical = true;
    }
    if (!maxPayment.every(element => { return element === maxPayment[0] })) {
        return false;
    } else {
        cardFeeIdentical = true;
    }
    if (!incrementalPayment.every(element => { return element === incrementalPayment[0] })) {
        return false;
    } else {
        cardFeeIdentical = true;
    }
    if (!variableFee.every(element => { return element === variableFee[0] })) {
        return false;
    } else {
        cardFeeIdentical = true;
    }
    return cardFeeIdentical;
}

